import { render, staticRenderFns } from "./RegTermsModal.vue?vue&type=template&id=1fd24fce&"
import script from "./RegTermsModal.vue?vue&type=script&lang=js&"
export * from "./RegTermsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports